import React from 'react';
import './Settings.css';

export default function Settings({
  theme,
  setTheme,
  autocommit,
  setAutocommit,
  autoresume,
  setAutoresume,
  onBack,
  onAdvancedSettings
}) {
  return (
    <div className="settings-container">
      <div className="settings-inner">
        <div className="settings-header">
          <h2>Settings</h2>
        </div>

      <div className="settings-content">
        <div className="settings-section">
          <h3>Appearance</h3>

          <div className="setting-item">
            <div className="setting-label">
              <span className="setting-name">Theme</span>
              <span className="setting-description">Choose light or dark mode</span>
            </div>
            <div className="setting-control toggle-switch">
              <button
                className={`toggle-option ${theme === 'light' ? 'active' : ''}`}
                onClick={() => setTheme('light')}
              >
                Light
              </button>
              <button
                className={`toggle-option ${theme === 'dark' ? 'active' : ''}`}
                onClick={() => setTheme('dark')}
              >
                Dark
              </button>
            </div>
          </div>
        </div>

        <div className="settings-section">
          <h3>Transactions</h3>

          <div className="setting-item">
            <div className="setting-label">
              <span className="setting-name">Autocommit</span>
              <span className="setting-description">Automatically commit transactions after countdown</span>
            </div>
            <div className="setting-control toggle-switch">
              <button
                className={`toggle-option ${!autocommit ? 'active' : ''}`}
                onClick={() => {
                  setAutocommit(false);
                  localStorage.setItem('autocommit', 'false');
                }}
              >
                Off
              </button>
              <button
                className={`toggle-option ${autocommit ? 'active' : ''}`}
                onClick={() => {
                  setAutocommit(true);
                  localStorage.setItem('autocommit', 'true');
                }}
              >
                On
              </button>
            </div>
          </div>
        </div>

        <div className="settings-section">
          <h3>Conversations</h3>

          <div className="setting-item">
            <div className="setting-label">
              <span className="setting-name">Resume last conversation</span>
              <span className="setting-description">Automatically load last conversation on app start</span>
            </div>
            <div className="setting-control toggle-switch">
              <button
                className={`toggle-option ${!autoresume ? 'active' : ''}`}
                onClick={() => {
                  setAutoresume(false);
                  localStorage.setItem('autoresumeChat', 'false');
                }}
              >
                Off
              </button>
              <button
                className={`toggle-option ${autoresume ? 'active' : ''}`}
                onClick={() => {
                  setAutoresume(true);
                  localStorage.setItem('autoresumeChat', 'true');
                }}
              >
                On
              </button>
            </div>
          </div>
        </div>

        <div className="settings-section settings-advanced-link">
          <button
            className="advanced-settings-btn"
            onClick={onAdvancedSettings}
          >
            Advanced Settings →
          </button>
        </div>
      </div>
      </div>
    </div>
  );
}
